import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import moment from 'moment';
import { findMonth } from '../../utils/methods';
import { withTranslation } from 'react-i18next';
import SkeletonLoder from '../common/skeletonLoder';
import { ImageUrl } from '../../utils/constants';
import { MonthlythemeContainer } from '../UserDashboard/styles';

class LeaderbordNameHeader extends Component {
  constructor() {
    super();
    this.state = {
      month: '',
    };
  }

  componentDidMount() {
    const d = new Date();
    const month = findMonth(d.getMonth());
    this.setState({
      month
    });
  }

  render() {
    const { 
      themesHeader, 
      t, 
      fontColor, 
      fontFamily,
      isLoading, 
      themeData 
    } = this.props;

    // Use passed themeData or fallback to Redux themesHeader
    const themeStyle = themeData || themesHeader || {};

    if (isLoading) {
      return <SkeletonLoder width={"1246px"} height={"134px"} style={{ margin: 'auto', marginBottom: '25px' }} />
    }

    return (
      <MonthlythemeContainer style={{display:'flex'}}
        backgroundImage={`${ImageUrl}/web/svg/${themeStyle?.image_url}`}
        fontColor={themeStyle?.text_color || themeStyle?.background_color || fontColor}
        fontFamily={fontFamily}
      >
        <div className="insideContainer" style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          width: '100%',
          padding: '0 20px'
        }}>
          {/* Left Section: Monthly Theme Only */}
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column',
            zIndex: 2,
            maxWidth: '60%'
          }}>
            <div className="monthly-theme-text">
              {t(themeStyle.month || this.state.month)}&apos;s {t("Monthly Theme")}
            </div>
            <div className="focus-on-fitness-text">
              {t(themeStyle.theme_text || "Focus on Fitness")}
            </div>
          </div>
        </div>
      </MonthlythemeContainer>
    )
  }
}

LeaderbordNameHeader.propTypes = {
  themesHeader: PropTypes.object,
  t: PropTypes.func,
  fontColor: PropTypes.string,
  fontFamily: PropTypes.string,
  isLoading: PropTypes.bool,
  themeData: PropTypes.object
};

const mapStateToProps = (state) => ({
  themesHeader: state.profileData.themesHeader,
  fontColor: state.theme.fontColor,
  fontFamily: state.theme.fontFamily
});

export default connect(mapStateToProps)(withTranslation()(LeaderbordNameHeader));